module.exports = "<svg id=\"290a5f42-7ce8-4ee4-8b14-f47064e7e3fc\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 46 46\"><title>arrow</title><path d=\"M23,46A23,23,0,1,1,46,23,23,23,0,0,1,23,46\"></path><path class=\"line\" d=\"M31,22.94a2.2,2.2,0,0,0-.22-.78l-6.14-9.39a.91.91,0,0,0-1.44-.19,1.52,1.52,0,0,0-.15,1.76l4.8,7.35H1.35a1.28,1.28,0,0,0,0,2.5h26.5l-4.8,7.36a1.54,1.54,0,0,0,.15,1.76.91.91,0,0,0,1.44-.2l6.14-9.39a1.28,1.28,0,0,0,.22-.78Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow.svg
// module id = 550
// module chunks = 1